import Axios from "axios";
import { baseUrl } from "../../../config/url-config/index";
import { getDataLogin } from "../../../utils/getDataLogin";

const Delete = (path, data) => {
  const promise = new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: `Bearer ${getDataLogin().token}` },
    };
    // Axios.delete(`${baseUrl}/${path}`, data, config)
    Axios.delete(`${baseUrl}/${path}`, config).then(
      (result) => {
        resolve(result);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export default Delete;
